import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const machinesWordList = [
  "apparatus",
  "button",
  "cable",
  "circuit",
  "coil",
  "computer",
  "current",
  "electricity",
  "energy",
  "engine",
  "handle",
  "instrument",
  "machine",
  "memory",
  "monitor",
  "motor",
  "power",
  "program",
  "pump",
  "robot",
  "screen",
  "spring",
  "turbine",
  "wheel",
  "wire",
];

export const machinesCollection: WordCollection = createCollection(
  "machines",
  "Machines & Mechanisms",
  machinesWordList,
  { icon: "robot-industrial", isWordlistViewable: true }, // Example icon
);
